import {
  Accordion as MuiAccordion,
  AccordionProps as MuiAccordionProps,
  AccordionSummary as MuiAccordionSummary,
  AccordionSummaryProps as MuiAccordionSummaryProps,
  AccordionDetails as MuiAccordionDetails,
  AccordionDetailsProps,
  styled,
} from '@mui/material';
import { createContext, FC, useContext } from 'react';
import { spacingSizes } from '../../theme';

type SpacingSize = keyof typeof spacingSizes;

const AccordionSpacingContext = createContext<SpacingSize>('lg');

type AccordionProps = MuiAccordionProps & {
  spacing?: SpacingSize;
};

const StyledAccordion = styled(MuiAccordion, {
  shouldForwardProp: (prop) => prop !== 'spacing',
})<{ spacing: SpacingSize }>(({ theme, spacing }) => ({
  paddingBottom: theme.spacing(theme.spacingSizes[spacing]),
}));

const StyledAccordionSummary = styled(MuiAccordionSummary, {
  shouldForwardProp: (prop) => prop !== 'spacing',
})<{ spacing: SpacingSize }>(({ theme, spacing }) => ({
  paddingTop: theme.spacing(theme.spacingSizes[spacing]),
}));

export const Accordion: FC<AccordionProps> = ({ spacing = 'lg', ...rest }) => (
  <AccordionSpacingContext.Provider value={spacing}>
    <StyledAccordion spacing={spacing} {...rest} />
  </AccordionSpacingContext.Provider>
);

export const AccordionSummary: FC<MuiAccordionSummaryProps> = (props) => {
  const spacing = useContext(AccordionSpacingContext);
  return <StyledAccordionSummary spacing={spacing} {...props} />;
};

export const AccordionDetails: FC<AccordionDetailsProps> = (props) => (
  <MuiAccordionDetails {...props} />
);
